import { useEffect, useState } from "react";

/**
 * `value` once it has held still for `ms`. Not use-debounce's `useDebounce`:
 * in 5.1 a call still pending at unmount re-arms its timer forever.
 */
export function useDebouncedValue<T>(value: T, ms: number): T {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const timer = window.setTimeout(() => setDebounced(value), ms);
        return () => window.clearTimeout(timer);
    }, [value, ms]);
    return debounced;
}
